var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-1343.000000, -443.000000)",
    fill: "#D1D1D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-copy",
    transform: "translate(651.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-edit",
    transform: "translate(692.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3510896,3.34268591 L1.34679846,14.359323 C1.29143595,14.4149025 1.25146073,14.4850913 1.2324249,14.5605206 L0.0127046514,19.4613559 C-0.0237806935,19.6088796 0.0195258309,19.7657724 0.127078202,19.8734377 C0.208456329,19.9549013 0.319339999,20 0.432761779,20 C0.467502164,20 0.503035697,19.9957125 0.53761742,19.9869786 L5.43331347,18.765819 C5.50961538,18.7467632 5.57893748,18.7069048 5.63430003,18.6514842 L16.639543,7.63564114 L12.3510896,3.34268591 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3657899,1.84061214 L18.1408348,0.614371086 C17.3221358,-0.205187305 15.8952423,-0.204393323 15.0774952,0.614371086 L13.5769965,2.1164449 L17.8652912,6.4092413 L19.3657899,4.90716748 C19.7747427,4.49794408 20,3.95326569 20,3.37396922 C20,2.79467276 19.7747427,2.24999432 19.3657899,1.84061214 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.b581b5c33acc64b1a4995f8028b004ff.svg";
export { ForwardRef as ReactComponent };